import React, { useState, useEffect } from "react";
import VinaySinghal from "../../assets/images/svg/vinaysimghal_img.svg";
import PareshRawal from "../../assets/images/svg/preshraval_img.svg";
import ManojJoshi from "../../assets/images/svg/manojjoshi_img.svg";
import KunalLalani from "../../assets/images/svg/kunallalani_img.svg";
import rajkumar_img from "../../assets/images/svg/rajkumar.jpg";
import SapnaChoudhary from "../../assets/images/svg/sapna_img.svg";
import ParagSanghvi from "../../assets/images/svg/praghsanghvi_img.svg";
import VinodBhanushali from "../../assets/images/svg/vinodbhanushali_img.svg";

const testimonials = [
  { name: "Vinay Singhal", role: "Founder, Stage App", text: "HKI Media is redefining regional media excellence. Their approach to skilling and storytelling is unparalleled and transformative for the Indian industry.", img: VinaySinghal },
  { name: "Paresh Rawal", role: "National Award Winning Actor", text: "HKI Media’s commitment to nurturing talent and producing world class content makes it a cornerstone of India’s evolving entertainment landscape.", img: PareshRawal },
  { name: "Manoj Joshi", role: "Renowned Actor", text: "HKI Media is bridging the gap between creativity and technology. Their dedication to low cost, high impact regional content is a true game changer.", img: ManojJoshi },
  { name: "Kunal Lalani", role: "Founder, Crayons Network", text: "HKI Media’s visionary model integrates skilling, production, and innovation seamlessly. They are a powerhouse shaping the future of media in India.", img: KunalLalani },
  { name: "Rajkumar Singh", role: "Founder, Global Music Junction", text: "With their focus on profitability and scalability, HKI Media is empowering the next generation of creators and changing the dynamics of monetization.", img: rajkumar_img },
  { name: "Sapna Choudhary", role: "Renowned Celebrity", text: "HKI Media is a beacon of opportunity for budding talent. Their GigMedia is revolutionizing how artists and agencies connect and collaborate.", img: SapnaChoudhary },
  { name: "Parag Sanghvi", role: "Renowned Producer", text: "HKI Media’s unique approach to regional and multilingual storytelling is exactly what India needs in today’s content driven world.", img: ParagSanghvi },
  { name: "Vinod Bhanushali", role: "CEO, Hitz Music", text: "HKI Media is setting new benchmarks in creative excellence. Their blend of skilling and production ensures the entertainment industry stays ahead.", img: VinodBhanushali },
];

const IndustryLeaders = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  // Auto-play flowing from Left to Right
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
    }, 4000);
    return () => clearInterval(interval);
  }, []);

 // Maps the cards into a 3D horizontal carousel
  const getPositionStyles = (index) => {
    const total = testimonials.length;
    let diff = index - activeIndex;

    // Handle circular array wrap-around
    if (diff < -2) diff += total;
    if (diff > total - 3) diff -= total;

    // Base default style (hidden cards in the back)
    let styles = {
      left: "50%",
      transform: "translate(-50%, -50%) scale(0.5)",
      opacity: 0,
      zIndex: 0,
      pointerEvents: "none",
    };

    // Center Zoomed (Active)
    if (diff === 0) {
      styles = { left: "50%", transform: "translate(-50%, -50%) scale(1)", opacity: 1, zIndex: 10, pointerEvents: "auto" };
    }
    // Immediate Right (Increased visibility)
    else if (diff === 1) {
      styles = { left: "78%", transform: "translate(-50%, -50%) scale(0.85)", opacity: 0.9, zIndex: 8, pointerEvents: "auto" };
    }
    // Far Right (Increased visibility)
    else if (diff === 2) {
      styles = { left: "98%", transform: "translate(-50%, -50%) scale(0.72)", opacity: 0.8, zIndex: 6, pointerEvents: "auto" };
    }
    // Immediate Left (Increased visibility)
    else if (diff === -1) {
      styles = { left: "22%", transform: "translate(-50%, -50%) scale(0.85)", opacity: 0.9, zIndex: 8, pointerEvents: "auto" };
    }
    // Far Left (Increased visibility)
    else if (diff === -2) {
      styles = { left: "2%", transform: "translate(-50%, -50%) scale(0.72)", opacity: 0.8, zIndex: 6, pointerEvents: "auto" };
    }
    return styles;
  };

  return (
    <div className="home-section-pad industry-leaders-section" style={{ overflow: "hidden" }}>
      <div className="container mb-5">
        <h2 className="section-heading">
          What Industry <span className="section-heading-accent">Leaders Say?</span>
        </h2>
        <p className="section-subtitle">
          Hear from the visionaries shaping the future of media alongside us.
        </p>
      </div>
      
      <div className="carousel-3d-container">
        {testimonials.map((item, index) => {
          const isActive = index === activeIndex;
          return (
            <div 
              key={index} 
              className={`carousel-3d-card ${isActive ? "active-carousel-card" : ""}`} 
              style={getPositionStyles(index)}
              onClick={() => setActiveIndex(index)}
            >
              <div className="card-top-section">
                <img loading="lazy" decoding="async" src={item.img} alt={item.name} className="carousel-avatar" />
                <div className="carousel-user-info">
                  <h4 className="carousel-name">{item.name}</h4>
                  <p className="carousel-role">{item.role}</p>
                </div>
              </div>
              <div className="card-bottom-section">
                <p className="carousel-text">&ldquo;{item.text}&rdquo;</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default IndustryLeaders;
